import { useSearchParams } from 'react-router-dom';
/**
 * Which item of a list is open in the side panel, kept in the address
 * (`?system=wata`): the link can be shared, a reload keeps the panel, Back closes
 * it. Opening pushes a history entry, switching to another item replaces it — so
 * Back closes the panel instead of replaying every item viewed.
 */
export function useUrlSelection(param) {
    const [params, setParams] = useSearchParams();
    const value = params.get(param) || null;
    const open = (next) => setParams((prev) => {
        const p = new URLSearchParams(prev);
        p.set(param, next);
        return p;
    }, { replace: value != null });
    const close = () => setParams((prev) => {
        const p = new URLSearchParams(prev);
        p.delete(param);
        return p;
    }, { replace: true });
    return { value, open, close };
}
